import { Grid, Typography, makeStyles } from '@material-ui/core';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getAllDepartments, showProgress } from '../../redux/actions/DealershipActions';
import { apiEndpoints } from '../../constants/apiEndpoints';
import service from '../../apis/service';
import { ErrorToast } from '../utils/Utils';

const useStyle = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    gap: '20px',
    marginTop: '10px',
  },
  item: {
    width: '25vw',
    wordWrap: 'break-word',
    maxHeight: '200px',
    overflowY: 'auto',
  },
  heading: {
    textAlign: 'left',
    fontWeight: 600,
    fontSize: '14px',
    lineHeight: '17px',
    fontStyle: 'normal',
    color: 'rgba(0, 0, 0, 0.4)',
    marginBottom: 0,
  },
  info: {
    wordBreak: 'break-all',
    textAlign: 'left',
    fontWeight: 500,
    fontSize: '12px',
    lineHeight: '21px',
    fontStyle: 'normal',
    color: 'black',
    marginTop: '5px',
  },
});

export default function LeftsideCert() {
  const classes = useStyle();
  const dispatch = useDispatch();
  const selectedCertInfo = useSelector((state) => state.certificateData.selectedCertInfo);
  const getAddDepartmentList = async () => {
    dispatch(showProgress(true));
    try {
      const res = await service.get(apiEndpoints.GET_DEPARTMENTS);
      const finalVal = res?.map?.((item) => ({ value: item.id, label: item?.title }));
      dispatch(getAllDepartments(finalVal));
    } catch (error) {
      ErrorToast(error);
    }
    dispatch(showProgress(false));
  };
  useEffect(() => {
    getAddDepartmentList();
  }, []);
  return (
    <Grid className={classes.container}>
      <Grid className={classes.item}>
        <Typography className={classes.heading}>Certification Code</Typography>
        <Typography className={classes.info}>{selectedCertInfo.code}</Typography>
      </Grid>
      <Grid className={classes.item}>
        <Typography className={classes.heading}>Overview</Typography>
        <Typography className={classes.info}>{selectedCertInfo.overview}</Typography>
      </Grid>
      <Grid className={classes.item}>
        <Typography className={classes.heading}>Skill Level</Typography>
        <Typography className={classes.info}>{selectedCertInfo.skill}</Typography>
      </Grid>
      <Grid className={classes.item}>
        <Typography className={classes.heading}>Duration</Typography>
        <Typography className={classes.info}>{selectedCertInfo.duration} days</Typography>
      </Grid>
      <Grid className={classes.item}>
        <Typography className={classes.heading}>Issuer Name</Typography>
        <Typography className={classes.info}>{selectedCertInfo.issuer}</Typography>
      </Grid>
      <Grid className={classes.item}>
        <Typography className={classes.heading}>Certification Reporting Code</Typography>
        <Typography className={classes.info}>{selectedCertInfo.courseCode || '--'}</Typography>
      </Grid>
    </Grid>
  );
}
